(() => {
  const init = (scope = document) => scope.querySelectorAll('[data-gallery]').forEach(gallery => {
    if (gallery.forgeGallery) return;
    const panels = [...gallery.querySelectorAll('[data-gallery-main]')], thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const viewport = gallery.querySelector('[data-gallery-viewport]'), stage = gallery.querySelector('[data-gallery-stage]'), dialog = gallery.querySelector('[data-gallery-dialog]'), host = gallery.querySelector('[data-gallery-modal-host]'), status = gallery.querySelector('[data-gallery-status]');
    if (!panels.length || !viewport || !dialog) return;
    const text = window.IF?.galleryText || {loading:'Loading image…',error:'This image could not load. Please try another image.',item:'Media'};
    const events = new AbortController(), signal = events.signal, points = new Map();
    let index = 0, requested = 0, sequence = 0, scale = 1, x = 0, y = 0, start = null, pinch = null, suppressClick = false, lastTap = 0, returnFocus = null, previousOverflow = '', zoomFrame = 0, prefetchTimer = 0;
    const listen = (el, type, fn, options = {}) => el.addEventListener(type, fn, {...options,signal});
    const hydrate = n => {
      const panel = panels[n], template = panel?.querySelector('template[data-gallery-template]');
      if (template) { template.replaceWith(template.content.cloneNode(true)); panel.querySelectorAll('img').forEach(i => { i.draggable = false; if (i.loading === 'lazy') i.loading = 'eager'; }); }
      return panel;
    };
    const currentImage = () => panels[index].querySelector('img.forge-gallery-image');
    const paintZoom = () => {
      zoomFrame = 0;
      const img = currentImage(); if (!img) return;
      const r = viewport.getBoundingClientRect(), ratio = img.naturalWidth / (img.naturalHeight || 1), w = Math.min(r.width,r.height*ratio), h = w / (ratio || 1);
      x = Math.max(-Math.max(0,(w*scale-r.width)/2),Math.min(Math.max(0,(w*scale-r.width)/2),x));
      y = Math.max(-Math.max(0,(h*scale-r.height)/2),Math.min(Math.max(0,(h*scale-r.height)/2),y));
      viewport.style.setProperty('--zoom-scale',scale); viewport.style.setProperty('--zoom-x',x+'px'); viewport.style.setProperty('--zoom-y',y+'px');
      viewport.dataset.zoomed = String(scale > 1.01);
    };
    const draw = () => { if (!zoomFrame) zoomFrame = requestAnimationFrame(paintZoom); };
    const resetZoom = () => { scale = 1; x = y = 0; points.clear(); pinch = null; draw(); };
    const promoteImage = () => { const img = currentImage(); if (img) img.sizes = dialog.open ? '100vw' : '(min-width:1280px) 580px,(min-width:768px) calc(50vw - 3rem),calc(100vw - 2.5rem)'; };
    const ready = async panel => {
      const img = panel?.querySelector('img.forge-gallery-image');
      if (!img) return;
      img.fetchPriority = 'auto';
      if (img.decode) { try { await img.decode(); } catch { if (!img.naturalWidth) throw Error('image'); } }
      else if (!img.complete) await new Promise((resolve,reject) => { img.addEventListener('load',resolve,{once:true});img.addEventListener('error',reject,{once:true}); });
    };
    const prefetch = () => {
      clearTimeout(prefetchTimer);
      if (panels.length < 2) return;
      prefetchTimer = setTimeout(() => { const n = (index+1)%panels.length; if (panels[n].dataset.galleryType === 'image' && !navigator.connection?.saveData) hydrate(n); },200);
    };
    const show = async value => {
      if (!Number.isFinite(value)) return;
      const n = ((value % panels.length)+panels.length)%panels.length, ticket = ++sequence;
      requested = n;
      if (n === index) return;
      const panel = hydrate(n); status.textContent = text.loading;
      try { await ready(panel); } catch { if (ticket === sequence) { requested = index; status.textContent = text.error; } return; }
      if (ticket !== sequence || !gallery.isConnected) return;
      panels.forEach((p,i) => { p.hidden = i !== n; if (i !== n) { p.querySelectorAll('video').forEach(v => v.pause()); p.querySelectorAll('iframe:not([data-gallery-video-src])').forEach(f => { const url = f.src; f.src = 'about:blank'; f.dataset.galleryVideoSrc = url; }); } });
      panel.querySelectorAll('iframe[data-gallery-video-src]').forEach(f => { f.src=f.dataset.galleryVideoSrc; delete f.dataset.galleryVideoSrc; });
      index = n; resetZoom(); promoteImage();
      thumbs.forEach((b,i) => { const selected=i===n;b.setAttribute('aria-pressed',String(selected));b.classList.toggle('border-primary',selected);b.classList.toggle('border-transparent',!selected); });
      gallery.querySelectorAll('[data-gallery-count]').forEach(c => { c.textContent=(n+1)+' / '+panels.length; });
      status.textContent = text.item+' '+(n+1)+' / '+panels.length; prefetch();
    };
    const close = () => { if (dialog.open) dialog.close(); };
    const open = () => {
      if (dialog.open) return;
      returnFocus = document.activeElement; previousOverflow = document.body.style.overflow;
      host.append(viewport); dialog.showModal(); document.body.style.overflow='hidden'; resetZoom(); promoteImage();
      gallery.querySelector('[data-gallery-close]').focus();
    };
    listen(dialog,'close',() => { stage.prepend(viewport); document.body.style.overflow=previousOverflow;resetZoom();promoteImage();if(returnFocus?.isConnected)returnFocus.focus(); });
    listen(gallery,'click',e => {
      const b=e.target.closest('button');
      if (b?.hasAttribute('data-gallery-prev')) { show(requested-1);return; }
      if (b?.hasAttribute('data-gallery-next')) { show(requested+1);return; }
      if (b?.hasAttribute('data-gallery-thumb')) { show(Number(b.dataset.galleryThumb));return; }
      if (b?.hasAttribute('data-gallery-open')) { open();return; }
      if (b?.hasAttribute('data-gallery-close')) { close();return; }
      if (b?.hasAttribute('data-gallery-zoom')) { if (!currentImage())return;scale=scale>1?1:2;x=y=0;draw();return; }
      if (!viewport.contains(e.target) || !currentImage()) return;
      if (suppressClick) { suppressClick=false;return; }
      if (!dialog.open) open(); else if (e.detail && e.pointerType !== 'touch') { scale=scale>1?1:2;x=y=0;draw(); }
    });
    listen(viewport,'pointerdown',e => {
      if (!currentImage() || e.button > 0) return;
      suppressClick=false;points.set(e.pointerId,{x:e.clientX,y:e.clientY});
      if (dialog.open) viewport.setPointerCapture(e.pointerId);
      if (points.size===1) start={x:e.clientX,y:e.clientY,panX:x,panY:y,moved:0,type:e.pointerType};
      else if (points.size===2) { const p=[...points.values()];pinch={distance:Math.hypot(p[1].x-p[0].x,p[1].y-p[0].y),scale};if(start)start.moved=100; }
    });
    listen(viewport,'pointermove',e => {
      if (!points.has(e.pointerId)) return;
      points.set(e.pointerId,{x:e.clientX,y:e.clientY});
      if (points.size===2 && dialog.open && pinch) { const p=[...points.values()];scale=Math.max(1,Math.min(4,pinch.scale*Math.hypot(p[1].x-p[0].x,p[1].y-p[0].y)/Math.max(1,pinch.distance)));draw();return; }
      if (!start) return;
      start.moved=Math.max(start.moved,Math.hypot(e.clientX-start.x,e.clientY-start.y));
      if (dialog.open && scale>1.01) { x=start.panX+e.clientX-start.x;y=start.panY+e.clientY-start.y;draw(); }
    });
    const release = (e,cancelled=false) => {
      if (!points.has(e.pointerId)) return;
      points.delete(e.pointerId);
      if (points.size) { pinch=null;if(start)start.moved=100;return; }
      if (!start) return;
      const gesture=start;start=null;pinch=null;
      const dx=e.clientX-gesture.x,dy=e.clientY-gesture.y;
      if (cancelled) { suppressClick=true;return; }
      suppressClick=gesture.moved>10;
      if (scale<=1.01 && Math.abs(dx)>=40 && Math.abs(dx)>Math.abs(dy)*1.25) { suppressClick=true;show(requested+(dx<0?1:-1));return; }
      if (dialog.open && gesture.type==='touch' && gesture.moved<10) {
        const now=Date.now();suppressClick=true;if(now-lastTap<300){scale=scale>1?1:2;x=y=0;draw();lastTap=0;}else lastTap=now;
      }
    };
    listen(window,'pointerup',e=>release(e));listen(viewport,'pointercancel',e=>release(e,true));
    listen(viewport,'dragstart',e=>e.preventDefault());
    listen(gallery,'keydown',e => {
      if (e.target.closest('video,model-viewer,iframe'))return;
      if (e.key==='ArrowRight') {e.preventDefault();show(requested+1);}
      else if(e.key==='ArrowLeft'){e.preventDefault();show(requested-1);}
      else if((e.key==='Enter'||e.key===' ') && e.target===viewport){e.preventDefault();open();}
    });
    gallery.forgeGallery={show,open,close,destroy:()=>{events.abort();clearTimeout(prefetchTimer);cancelAnimationFrame(zoomFrame);if(dialog.open)dialog.close();}};
    panels[0].querySelectorAll('img').forEach(i => {i.draggable=false;});
    ready(panels[0]).then(prefetch).catch(()=>{});
  });
  init();document.addEventListener('shopify:section:load',e=>init(e.target));document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-gallery]').forEach(g=>g.forgeGallery?.destroy()));
})();
